import React, { FC } from "react";
import svgIcons from "../assets/svg/svgIcons";

type TickCheckboxProps = {
  wrapperClass?: string;
  id: string;
  isChecked?: boolean;
  isReadonly?: boolean;
  disabled?: boolean;
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  skinned?: boolean;
};

const TickCheckbox: FC<TickCheckboxProps> = ({
  wrapperClass = "relative w-6 h-6 flex items-center justify-center",
  id,
  isChecked = false,
  isReadonly = false,
  disabled = false,
  handleChange,
  onClick,
  skinned = true,
}) => {
  return (
    <>
      {skinned ? (
        <span className={`group ${wrapperClass}`}>
          <input
            checked={isChecked}
            className="opacity-0 absolute w-6 h-6 peer cursor-pointer"
            disabled={disabled}
            id={id}
            onClick={onClick}
            onChange={handleChange}
            type="checkbox"
            readOnly={isReadonly}
          />
          <img
            src={isChecked ? svgIcons.CheckboxChecked : svgIcons.Checkbox}
            alt="checkbox"
            className={`rounded-sm pointer-events-none touch-none ${!disabled && !isReadonly ? "peer-hover:ring-2 peer-hover:ring-accent-blue-pale" : ""} peer-focus:ring-2 peer-focus:ring-accent-blue-dark${isReadonly ? " grayscale cursor-not-allowed opacity-50" : " group-hover:opacity-80"}`}
          />
        </span>
      ) : (
        <div className={wrapperClass}>
          <input
            checked={isChecked}
            className={`w-4 h-4 text-accent-blue-dark bg-gray-100 border-gray-300 rounded focus:ring-accent-blue-dark dark:focus:ring-accent-blue-dark dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600${isReadonly ? " grayscale cursor-not-allowed" : ""}`}
            disabled={disabled}
            id={id}
            onClick={onClick}
            onChange={handleChange}
            type="checkbox"
            readOnly={isReadonly}
          />
        </div>
      )}
    </>
  );
};
export default TickCheckbox;
